import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { EMPTY, Observable } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EnvironmentService } from '../services/environment.service';

@Injectable()
export class HttpApiCallInterceptor implements HttpInterceptor {
    managementService: any;

    constructor(
        private authService: MsalService,
        private EnvironmentService: EnvironmentService
    ) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (this.check(request.url)) {
            return next.handle(request);
        } else {
            const JWT = localStorage.getItem('msal.accessToken');
            let isTokenReloadRequire;

            if (JWT) {
                const jwtPayload = JSON.parse(window.atob(JWT.split('.')[1]));
                isTokenReloadRequire = new Date(jwtPayload.exp * 1000) < new Date();
            } else {
                isTokenReloadRequire = true;
            }
            switch (isTokenReloadRequire) {
                // * this will call the token api first and then acutaul api
                case true:
                    return this.authService
                        .acquireTokenSilent({
                            scopes: environment.scopes,
                            account: this.authService.instance.getActiveAccount(),
                            authority: environment.b2cPolicies.authorities.signUpSignIn.authority,
                        })
                        .pipe(
                            tap((response) => {
                                localStorage.setItem('msal.accessToken', response.accessToken);
                            }),
                            switchMap(() => {
                                request = request.clone({
                                    setHeaders: {
                                        Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
                                    },
                                });
                                return next.handle(request);
                            }),
                            catchError((err) => {
                                // TODO logout user here or
                                this.authService.logout();
                                return EMPTY;
                            })
                        );

                // * token is already valid so not calling token api directly passing the request
                case false:
                    return next.handle(request);
            }
        }
        // return next.handle(request);
    }

    check(apiUrl: string) {
        // TODO here we need to add all the api's which is anonymous which doesnt requires token
        let temp = apiUrl.split('api/');
        return apiUrl.includes('GetSharedContentsForLandingPage') || apiUrl.includes('i18n') || apiUrl.includes('sendcontactusemail');
    }
}
